'use client'

import { RoomWithPrice } from '@/types/Misc'
import React, { ReactElement, useEffect, useState } from 'react'
import HotelRoom from '@/components/ui/hotel-rooms/HotelRoom'
import { HotelRoomModal } from '@/components/ui/hotel-rooms/HotelRoomModal'
import { Breakpoints, HotelSlider } from '@/components/hotel/HotelSlider'
import { SHOW_ROOM_DETAILS_EVENT } from '@/components/hotel/constants'
import { ModalNew } from '@/components/common/ModalNew'

export function HotelRoomsSlider(props: {
  focus?: number | 'center'
  rooms: RoomWithPrice[]
  descriptionRoom: string
  onSelect?: (roomCode: string) => void
  selectedRoomCode?: string
  fixedWidth?: number
  breakpoints: Breakpoints
}): ReactElement | null {
  const [selectedModalIndex, setSelectedModalIndex] = useState<number | undefined>()

  function closeModal() {
    setSelectedModalIndex(undefined)
  }

  useEffect(() => {
    function handleEvent(
      event: CustomEvent<{
        code: string
      }>,
    ) {
      setSelectedModalIndex(props.rooms.findIndex((room) => room.code === event.detail.code))
    }

    window.addEventListener(SHOW_ROOM_DETAILS_EVENT, handleEvent)

    return () => {
      window.removeEventListener(SHOW_ROOM_DETAILS_EVENT, handleEvent)
    }
  }, [])

  const sliderElements = props.rooms.map((room, index) => (
    <HotelRoom
      room={room}
      key={room.code}
      onSelect={props.onSelect}
      selected={room.code === props.selectedRoomCode}
      price={room.price}
      showMoreDetailsClicked={() => setSelectedModalIndex(index)}
      withinSlider
    />
  ))

  return (
    <>
      {selectedModalIndex !== undefined && (
        <ModalNew
          close={closeModal}
          isOpen={selectedModalIndex !== undefined}
          title={''}
          className="max-w-[640px] sm:max-w-[640px]"
        >
          <HotelRoomModal
            room={props.rooms[selectedModalIndex]}
            key={props.rooms[selectedModalIndex].code}
          />
        </ModalNew>
      )}
      <HotelSlider
        sliderElements={sliderElements}
        selectedIndex={
          props.selectedRoomCode
            ? props.rooms.findIndex((room) => room.code === props.selectedRoomCode)
            : undefined
        }
        usedWithoutMargin
        fixedWidth={props.fixedWidth}
        focus={props.focus}
        breakpoints={props.breakpoints}
      />
    </>
  )
}
